'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  NAMESPACE: 'namespace',
  STORY: 'story'
};